import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/presellContent';
export function SocialProof() {
  return <section id="proof" className="w-full bg-[#F7F9F8]" data-id="element-51" data-mp="3baf9pl3so48v">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-52" data-mp="3fbios5e0pw91">
        <h2 className="text-2xl md:text-3xl font-bold text-[#22322C] text-center" data-id="element-53" data-mp="3k2h698aqt0dv">
          Why So Many People Are Paying Attention
        </h2>

        <ul className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-54" data-mp="3p0sgvl8v3ex5">
          {testimonials.map(({
          id,
          quote,
          name,
          age,
          image
        }) => <li key={id} className="bg-white rounded-2xl border border-[#E5E9E7] px-6 py-7 flex flex-col" data-id="element-55" data-mp="3u2hu97jk44oe">
              <div className="flex gap-1" role="img" aria-label="Rated 5 out of 5" data-id="element-56" data-mp="6uxnlarmo7gh">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="w-4 h-4 text-[#D8A44A] fill-[#D8A44A]" aria-hidden="true" data-id="element-57" data-mp="28o3oml6l1h6a" data-mpi={index} />)}
              </div>

              <blockquote className="mt-5 text-[#4A5D50] leading-relaxed" data-id="element-58" data-mp="2roujq9xbo9c">
                "{quote}"
              </blockquote>

              <div className="mt-auto pt-6 flex items-center gap-3" data-id="element-59" data-mp="3p188nl4svnt7">
                <img src={image} alt={`Portrait of ${name}`} className="w-11 h-11 rounded-full object-cover" loading="lazy" data-id="element-60" data-mp="3oyviwlssw95l" />
                <p className="text-sm" data-id="element-61" data-mp="lievvajuj303">
                  <span className="font-semibold text-[#22322C]" data-id="element-62" data-mp="gk5316llgehn">{name}</span>
                  <span className="text-[#8A9A8F]" data-id="element-63" data-mp="bmbuw80qdaeq"> · {age}</span>
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}